import { useEffect, useState } from "react";
import { Breakpoint } from "../utils/media-query";
import Head from "next/head";
const HowToOrder = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const [isDesktop, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>How to Order | Aurum Lab</title>
        <meta
          name="description"
          content="Berbelanja di Aurum Lab sangatlah mudah dan aman. Ikuti beberapa langkah yang ada pada halaman ini untuk melakukan order"
        />
      </Head>
      <main>
        {isMounted && (
          <div className="center mt-3">
            <div className={isDesktop ? "container" : "container-mobile"}>
              <h2 className="center mb-1">How to order</h2>
              <div className="container-mobile">
                <ol>
                  <li className="my-05">
                    Pilih perhiasan yang kamu suka beserta ukuran / warna nya
                    dan klik “Add to Bag”
                  </li>
                  <li className="my-05">
                    Klik “Check out” untuk menyelesaikan proses transaksi
                  </li>
                  <li className="my-05">
                    Isi seluruh data diri dan pilih metode pembayaran yang kamu
                    inginkan
                  </li>
                  <li className="my-05">
                    Klik “Proceed” dan nantikan perhiasan milik mu tiba
                  </li>
                </ol>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};
export default HowToOrder;
